import type React from 'react'
import { cn } from 'lib/utils'
import { Tooltip as ShadTooltip, TooltipTrigger, TooltipContent } from './base/tootlip' // replace with your actual import path

interface TooltipProps {
  content: React.ReactNode | string
  children: React.ReactNode
  delayDuration?: number
  onOpenChange?: (isOpen: boolean) => void
}
export const Tooltip: React.FC<TooltipProps & React.ComponentProps<typeof TooltipContent>> = ({
  content,
  children,
  delayDuration = 700,
  onOpenChange,
  ...tooltipProps
}) => (
  <ShadTooltip delayDuration={delayDuration} onOpenChange={onOpenChange}>
    <TooltipTrigger asChild>{children}</TooltipTrigger>
    {content && (
      <TooltipContent {...tooltipProps} className={cn('max-w-80', tooltipProps.className)}>
        {typeof content === 'string' ? <p>{content}</p> : content}
      </TooltipContent>
    )}
  </ShadTooltip>
)
